import { Box, Text } from '@stitch-fix/mode-react';
import { SelfieUpload } from './steps/Selfie/SelfieUpload';
import { useGetClientSelfieQuery } from './graphql/getClientSelfie';
import PhotoTips from './PhotoTips';
import { SupportedBusinessLine } from './Onboarding';
const ReOnboardingSelfie = ({
  businessLine
}: {
  businessLine: SupportedBusinessLine;
}) => {
  const {
    data: clientData,
    refetch: refetchSelfie
  } = useGetClientSelfieQuery();
  const existingSelfieUrl = clientData?.client?.selfieImageUrl || null;
  return <Box maxWidth={54} mx="auto" display="flex" style={{
    flexDirection: 'column',
    flex: 1
  }}>
      <Text setting="title-xsmall" mb={1.5} color="gray-16">
        <strong>Add a headshot</strong>
      </Text>
      <Box mb={3}>
        <SelfieUpload existingImageUrl={existingSelfieUrl} onChange={() => refetchSelfie()} />
      </Box>
      <PhotoTips businessLine={businessLine} mode="headshot" showProfileSettingsCopy={false} />
    </Box>;
};
export default ReOnboardingSelfie;